import React, {PropTypes} from 'react';
const s = require('./BugFixSingleAccordionArticle.scss');
import Tags from '../Tags/Tags';

const BugFixSingleAccordionArticle = ({date, title, content, links, index}) => {
  return (
    <li className={s.gridItem}>
      <input type="checkbox" hidden className={s.toggleContent} id={`check-${index}`}/>
      <label className={s.svgArrow} htmlFor={`check-${index}`}>
        <svg height="10.406" width="16" viewBox="0 0 16 10.406" className={s.svgWrapper}>
          <defs/>
          <path className={s.svgCls} id="arrow" d="M1481,619.812l-7,7.01-7-7.01" transform="translate(-1466 -617.406)"/>
        </svg>
      </label>
      <h2 className={s.title} data-hook="article-title">{title}</h2>
      <div className={s.tagWrapper}>
        <Tags data-hook="article-labels" links={links} size="16"/>
        <label className={s.date} data-hook="article-date">
          <svg height="12" width="12" viewBox="0 0 12 12" className={s.clockIcon}>
            <defs/>
            <path id="Time" d="M643,635a6,6,0,1,0,6,6A6,6,0,0,0,643,635Zm0,11a5,5,0,1,1,5-5A5.006,5.006,0,0,1,643,646Zm0-7h-1v3h3v-1h-2v-2Z" transform="translate(-637 -635)"/>
          </svg>
          {date}</label>
      </div>
      <div data-hook="article-content" className={s.articleContent}>{content}</div>
      <hr/>
    </li>
  );
};

BugFixSingleAccordionArticle.propTypes = {
  date: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  index: PropTypes.string.isRequired,
  content: PropTypes.object.isRequired,
  links: PropTypes.array.isRequired
};

export default BugFixSingleAccordionArticle;



// WEBPACK FOOTER //
// ./components/partial/BugFixSingleAccordionArticle/BugFixSingleAccordionArticle.js